import type { CSSProperties } from "react";

export interface WorkforceSubheadProps {
  total: number;
  working: number;
  awaiting: number;
}

export function WorkforceSubhead({ total, working, awaiting }: WorkforceSubheadProps) {
  const parts: string[] = [`${total} hire${total === 1 ? "" : "s"}`];
  if (working > 0) parts.push(`${working} at work`);
  if (awaiting > 0) parts.push(`${awaiting} awaiting you`);

  const style: CSSProperties = {
    fontSize: 13,
    fontWeight: 400,
    color: "var(--color-text-secondary)",
    fontFamily: "var(--font-sans)",
    fontVariantNumeric: "tabular-nums",
    marginTop: 2,
  };

  return <div style={style}>{parts.join(" · ")}</div>;
}
